module.exports = __webpack_public_path__ + "static/media/tree-step-4_1.48d58ffa.svg";